(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_collection-card-image"] && !Shopify.designMode) return;
  try {
    /**
   * Synced Pattern Effect
   * 
   * Makes the pattern in collection cards move in sync with the body's
   * background, creating the illusion of a single continuous pattern.
   * 
   * Desktop (background-attachment: fixed):
   * - Pattern stays fixed relative to viewport
   * - Offset by card's viewport position
   * 
   * Mobile (background-attachment: scroll):
   * - Pattern scrolls with page
   * - Offset by card's document position (not viewport)
   */
  (function() {
    let ticking = false;
    let patterns = [];
    const isMobile = () => window.innerWidth <= 768;
    
    function cachePatterns() {
      patterns = Array.from(document.querySelectorAll('.collection-card__synced-pattern'));
    }
    
    function updatePatternPositions() {
      const mobile = isMobile();
      
      patterns.forEach(pattern => {
        const card = pattern.closest('.collection-card__image--layered');
        if (!card) return;
        
        const rect = card.getBoundingClientRect();
        
        if (mobile) {
          // Mobile: background-attachment: scroll
          // Pattern scrolls with page, so offset by document position
          const scrollY = window.pageYOffset || document.documentElement.scrollTop;
          const scrollX = window.pageXOffset || document.documentElement.scrollLeft;
          
          // Card's position in the document
          const docTop = rect.top + scrollY;
          const docLeft = rect.left + scrollX;
          
          // Offset pattern to align with body's scrolling background
          pattern.style.setProperty('--pattern-x', `${-docLeft}px`);
          pattern.style.setProperty('--pattern-y', `${-docTop}px`);
        } else {
          // Desktop: background-attachment: fixed
          // Pattern is fixed to viewport, offset by viewport position
          pattern.style.setProperty('--pattern-x', `${-rect.left}px`);
          pattern.style.setProperty('--pattern-y', `${-rect.top}px`);
        }
        
        // Show pattern after positioning to prevent CLS
        pattern.classList.add('is-positioned');
      });
      
      ticking = false;
    }
    
    function requestUpdate() {
      if (!ticking) {
        requestAnimationFrame(updatePatternPositions);
        ticking = true;
      }
    }
    
    function init() {
      cachePatterns();
      updatePatternPositions();
      
      // Use requestAnimationFrame for smooth updates
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', () => {
        cachePatterns();
        requestUpdate();
      }, { passive: true });
      
      // Handle orientation change on mobile
      window.addEventListener('orientationchange', () => {
        setTimeout(() => {
          cachePatterns();
          updatePatternPositions();
        }, 100);
      });
    }
    
    // Initialize
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    
    // Handle dynamic content loading
    setTimeout(init, 100);
    setTimeout(init, 500);
    setTimeout(init, 1000);
  })();
  } catch(e) { console.error(e); }
})();

})();
